import PropTypes from 'prop-types'
import { Button, Modal } from '@driftt/tide-core-legacy'

import 'styles/components/settings/inboxes/DeleteConfirmModal.styl'

const DeleteConfirmModal = React.createClass({
  propTypes: {
    onClose: PropTypes.func,
    title: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    confirmLabel: PropTypes.string,
    disableButtons: PropTypes.bool,
    disableCancel: PropTypes.bool,
    disableConfirm: PropTypes.bool,
  },

  render() {
    const {
      onClose,
      title,
      children,
      disableButtons = false,
      disableCancel = false,
      disableConfirm = false,
      onConfirm,
      confirmLabel,
    } = this.props
    return (
      <div className="DeleteConfirm">
        <Modal
          title={title}
          open={true}
          size="small"
          onClose={onClose}
          type="warning">
          <div className="container">
            <div className="content">{children}</div>
            <div className="bottom">
              <div className="bottom-divider" />
              <div className="button-container">
                <Button type="secondary" onClick={onConfirm} disabled={disableButtons || disableConfirm}>
                  {confirmLabel || 'Delete'}
                </Button>
                <Button type="tertiary" onClick={onClose} disabled={disableButtons || disableCancel} className="delete-confirm-modal-cancel-button">
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    )
  },
})

export default DeleteConfirmModal



// WEBPACK FOOTER //
// ./src/scripts/components/settings/DeleteConfirmModal.js